import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.sort.js";
// 定数
var classroomListLimit = 2;
var __default__ = {
  name: "TeachersIndex",
  head: {
    title: function title() {
      return {
        inner: "教員一覧"
      };
    },
    meta: []
  },
  computed: _objectSpread({}, mapState(["grades"]))
};
import { ref, reactive, computed } from "vue";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import RowItem from "../RowItem";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    var isLoading = reactive({
      teachers: true
    });
    var teachers = ref([]); // API からとってきたオリジナルデータ

    var filterTeachers = ref([]); // filterしたデータ

    var setData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getData("reader/get_teachers_with_classrooms");

              case 2:
                data = _context.sent;
                teachers.value = filterTeachers.value = reformatTeachers(data.items);
                isLoading.teachers = false;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function setData() {
        return _ref.apply(this, arguments);
      };
    }();

    var reformatTeachers = function reformatTeachers(originalList) {
      var newList = [];
      originalList.forEach(function (v) {
        // 現在の教師がすでに newList にいるかチェック（いる場合は複数クラスを担任していることになる）
        // みつからなければ新規作成。
        // 見つかった場合はそこに push
        var duplicatedTeacher = newList.find(function (_ref2) {
          var id = _ref2.id;
          return id === v.id;
        });
        var classroomObj = createTeacherClassroomObj(v);

        if (duplicatedTeacher) {
          if (classroomObj) {
            duplicatedTeacher.classrooms.push(classroomObj);
          }
        } else {
          newList.push({
            id: v.id,
            user_id: v.user_id,
            role_id: v.role_id,
            name: v.name,
            teacher_number: v.teacher_number,
            email: v.email,
            grade_index: v.fiscal_year ? null : v.grade_index,
            classroom_index: v.classroom_index,
            classrooms: classroomObj ? [classroomObj] : [],
            fiscal_year: v.fiscal_year,
            school_id: v.school_id
          });
        }
      });
      return newList;
    };

    var createTeacherClassroomObj = function createTeacherClassroomObj(v) {
      return !v.fiscal_year && v.classroom_id ? {
        classroom_id: v.classroom_id,
        classroom_name: v.classroom_name,
        grade_id: v.grade_id,
        grade_name: v.grade_name
      } : null;
    };

    var filterKeyword = ref("");
    var filterGrade = ref("");

    var handleFilterData = function handleFilterData(e) {
      e.preventDefault();
      filterTeachers.value = filterData();
    };

    var filterData = function filterData() {
      if (filterGrade.value && filterKeyword.value) {
        return teachers.value.filter(function (v) {
          return v.classrooms && v.classrooms.find(function (v2) {
            return v2.grade_id === filterGrade.value;
          }) && Object.keys(v).some(function (k) {
            return String(v[k]).indexOf(filterKeyword.value) > -1;
          });
        });
      } else if (filterGrade.value) {
        return teachers.value.filter(function (v) {
          return v.classrooms && v.classrooms.find(function (v2) {
            return v2.grade_id === filterGrade.value;
          });
        });
      } else if (filterKeyword.value) {
        return teachers.value.filter(function (v) {
          return Object.keys(v).some(function (k) {
            return String(v[k]).indexOf(filterKeyword.value) > -1;
          });
        });
      }

      return teachers.value;
    };

    var sortStatus = reactive({
      key: "name",
      order: "desc"
    });

    var changeSort = function changeSort(key, order) {
      sortStatus.key = key;
      sortStatus.order = order;
    }; // filterTeachersかsortKeyに変更があったら副作用的に実行する


    var visibleTeachers = computed(function () {
      return sortData();
    });

    var sortData = function sortData() {
      return filterTeachers.value.sort(function (a, b) {
        var v = 0;

        if (sortStatus.key === "name") {
          // unicode順？に並べる
          if (a.name < b.name) {
            v = -1;
          } else if (a.name > b.name) {
            v = 1;
          }
        } else if (sortStatus.key === "role") {
          // 管理者->一般の順にしつつ,グループ内ではname順にする
          if (a.role_id < b.role_id) {
            v = -1;
          } else if (a.role_id > b.role_id) {
            v = 1;
          } else {
            if (a.name < b.name) {
              v = -1;
            } else if (a.name > b.name) {
              v = 1;
            }
          }
        } else if (sortStatus.key === "classroom") {
          // 基本はapiから取得したクラス順に準拠しつつ、グループ内ではname順にする
          if (a.grade_index < b.grade_index) {
            v = -1;
          } else if (a.grade_index > b.grade_index) {
            v = 1;
          } else {
            if (a.classroom_index < b.classroom_index) {
              v = -1;
            } else if (a.classroom_index > b.classroom_index) {
              v = 1;
            } else {
              if (a.name < b.name) {
                v = -1;
              } else if (a.name > b.name) {
                v = 1;
              }
            }
          }
        }

        return sortStatus.order === "desc" ? v : -1 * v;
      });
    }; // created


    setData();
    return {
      __sfc: true,
      classroomListLimit: classroomListLimit,
      isLoading: isLoading,
      teachers: teachers,
      filterTeachers: filterTeachers,
      setData: setData,
      reformatTeachers: reformatTeachers,
      createTeacherClassroomObj: createTeacherClassroomObj,
      filterKeyword: filterKeyword,
      filterGrade: filterGrade,
      handleFilterData: handleFilterData,
      filterData: filterData,
      sortStatus: sortStatus,
      changeSort: changeSort,
      visibleTeachers: visibleTeachers,
      sortData: sortData,
      RowItem: RowItem
    };
  }
});